import Container from "react-bootstrap/Container";
import { useAppContext } from "../../../_context";

const Employees = ({ employees }) => {
  const [{ tx }] = useAppContext();

  return (
    <section className="section-padding-y employees-section">
      <Container>
        {/* <Row className="mb-6">
          <Col className="text-center m-auto" md={8}>
            <h2>{tx["The team"]}</h2>
            <p>
              {
                tx[
                  "These are the superstars that we’re lucky to call our team. Each bringing their own skills, experience and enthusiasm to make RacketPal one of the most fun and exciting places to work."
                ]
              }
            </p>
          </Col>
        </Row> */}
        {/* <Row>
          <Col xs={12} className="d-flex flex-wrap justify-content-center">
            {employees.map((employee, index) => {
              return <Employee key={index} index={index} employee={employee} />;
            })}
          </Col>
        </Row> */}
      </Container>
    </section>
  );
};

export default Employees;
